<ul *ngIf="choices?.length > 0" #dropdownMenu class="dropdown-menu" [style.bottom.px]="64"
  [style.left.px]="position?.left">
  <li *ngFor="let choice of choices; trackBy:trackById" [class.active]="activeChoice === choice">
    <a href="javascript:;" (click)="selectChoice.next(choice)">
      <img *ngIf="choice.icon" [src]="choice.icon" class="autocomplete-icon" />
      {{ choice.key }}
    </a>
  </li>
</ul>
